export default {
  PageData: 1,
  Summary: 2,
}
